import { useLiveQuery } from 'dexie-react-hooks';
import { useCallback, useEffect, useState } from 'react';
import { replica } from '@/shared/sync/replica';

type StorageInfo = {
  readonly persisted: boolean;
  readonly usage: number | undefined;
};

/** Whether the browser may evict this device's copy, how much it uses, and its files. */
export function useStorageInfo() {
  const [info, setInfo] = useState<StorageInfo>();
  const refresh = useCallback(async function readStorage() {
    const persisted = (await navigator.storage?.persisted?.()) ?? false;
    const estimate = await navigator.storage?.estimate?.();
    setInfo({ persisted, usage: estimate?.usage });
  }, []);
  useEffect(
    function readOnMount() {
      void refresh();
    },
    [refresh],
  );
  const files = useLiveQuery(async function countFiles() {
    const all = await replica.db.blobs.toArray();
    return {
      count: all.length,
      size: all.reduce((sum, blob) => sum + blob.size, 0),
      pending: all.filter((blob) => !blob.uploaded).length,
    };
  });
  return { info, files, refresh };
}
